var map = {
	"./3223.svg": 9671,
	"./airbnb.svg": 7248,
	"./alibaba.svg": 2259,
	"./aliexpress.svg": 526,
	"./amazon.svg": 8584,
	"./aol.svg": 3828,
	"./apple.svg": 1548,
	"./auto_ru.svg": 1942,
	"./badoo.svg": 4875,
	"./baidu.svg": 3851,
	"./bigo_live.svg": 1782,
	"./blablacar.svg": 9823,
	"./bolt.svg": 8628,
	"./burgerking.svg": 8082,
	"./careem.svg": 9967,
	"./cliqq.svg": 6799,
	"./dent.svg": 3456,
	"./depop.svg": 5474,
	"./discord.svg": 8028,
	"./douban.svg": 7116,
	"./douyu.svg": 1269,
	"./ebay.svg": 4201,
	"./faceit.svg": 5573,
	"./fetlife.svg": 3899,
	"./g2a.svg": 1464,
	"./gameflip.svg": 5194,
	"./gett.svg": 4513,
	"./glovo.svg": 5678,
	"./google.svg": 3984,
	"./hezzl.svg": 9844,
	"./homeaway.svg": 9264,
	"./hotmail.svg": 8813,
	"./hqtrivia.svg": 3113,
	"./icq.svg": 9691,
	"./imo.svg": 7379,
	"./inboxlv.svg": 6567,
	"./instagram.svg": 673,
	"./jiayuan.svg": 8568,
	"./kakaotalk.svg": 6772,
	"./keybase.svg": 2659,
	"./kwai.svg": 5931,
	"./linemessenger.svg": 6735,
	"./linkedin.svg": 8500,
	"./livescore.svg": 6729,
	"./lyft.svg": 623,
	"./maplesea.svg": 4044,
	"./meetme.svg": 3813,
	"./michat.svg": 2273,
	"./microsoft.svg": 9852,
	"./mymusictaste.svg": 1950,
	"./naver.svg": 3785,
	"./netease.svg": 1191,
	"./netflix.svg": 1671,
	"./nike.svg": 4090,
	"./nttgame.svg": 8704,
	"./olacabs.svg": 9705,
	"./olx.svg": 4190,
	"./oracle.svg": 6944,
	"./others.svg": 6560,
	"./periscope.svg": 9056,
	"./plenty_of_fish.svg": 5399,
	"./seagm.svg": 197,
	"./sheerid.svg": 3709,
	"./shopee.svg": 9585,
	"./skout.svg": 7171,
	"./snapchat.svg": 6322,
	"./steam.svg": 8650,
	"./tantan.svg": 177,
	"./taobao.svg": 666,
	"./telegram.svg": 4588,
	"./tencentqq.svg": 1217,
	"./ticketmaster.svg": 9898,
	"./tiktok.svg": 5519,
	"./tinder.svg": 5354,
	"./truecaller.svg": 9841,
	"./twitter.svg": 3961,
	"./uber.svg": 1430,
	"./viber.svg": 4827,
	"./wechat.svg": 5655,
	"./weibo.svg": 5331,
	"./whatsapp.svg": 3881,
	"./whatsaround.svg": 6963,
	"./wolt.svg": 1448,
	"./yahoo.svg": 5777,
	"./yalla.svg": 4408,
	"./yandeks.svg": 3490,
	"./zadarma.svg": 2026,
	"./zenly.svg": 5728,
	"./zoho.svg": 7291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;